import { render } from "./HomeIcon.vue?vue&type=template&id=3685bce4&scoped=true"
const script = {}

import "./HomeIcon.vue?vue&type=style&index=0&id=3685bce4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3685bce4"]])

export default __exports__